import React, { useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  Toolbar,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useParams } from "react-router-dom";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL, DOMAIN } from "../../global";
import moment from "moment";
import axios from "axios";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { toPng } from "html-to-image";
import headerImage from "../image/visibleSafety/letterHead.png";
import footerImage from "../image/visibleSafety/footer_VCC1.png";
import vssLogo from "../image/visibleSafety/himtexLogo.png";
import vssStamp from "../image/visibleSafety/himtexStamp.png";
import haryanaStamp from "../image/visibleSafety/COMPETENT PERSON HARYANA.png";
import rajasthanStamp from "../image/visibleSafety/COMPETENT PERSON RAJASTHAN STAMP.png";
import Sign from "../image/visibleSafety/sign.png";

import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import QRCode from "react-qr-code";
import { generatePDF1 } from "./print";

let certificationNote = [
  {
    id: 3,
    label:
      "I certify that on <b>{date}</b> the pressure vessel or plant described above was thoroughly cleaned and (so far as its constructions permits) made accessible for thorough examination and for such tests as were necessary for through examination and that on the said date, I thoroughly examined this pressure vessel or plant including its fittings and the above is true report of my examination.",
  },
  {
    id: 2,
    label:
      "I/We certify that on <b>{date}</b>, I/We thoroughly examined the above mentioned lifting machine, chain/rope/lifting tackle and that the above is a correct report of the result.",
  },
  {
    id: 4,
    label:
      "I certify that on <b>{date}</b>, the above mentioned Tank was thoroughly examined including its fittings and the above is true report of my examination.",
  },
  {
    id: 5,
    label:
      "I/We certify that on <b>{date}</b>, I/We thoroughly examined the above mentioned dangerous machine and found working satisfactorily and the above is a correct report of the result.",
  },
  {
    id: 1,
    label:
      "I certify that on <b>{date}</b>, I thoroughly examined the hoist or lift and that the above is a correct report of the result.",
  },
];

const FormPrint = ({ selectedFormID, selectedTemplateID }) => {
  const [inputStates, setInputStates] = React.useState({});
  const [inputFields, setInputFields] = React.useState([]);
  const [filteredInputFields, setfilteredInputFields] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { reportID, templateID } = useParams();
  const [totalReportCount, setTotalReportCount] = React.useState(0);
  const [newReportID, setNewReportID] = React.useState(
    reportID || selectedFormID
  );
  const [newTemplateID, setNewTemplateID] = React.useState(
    templateID || selectedTemplateID
  );
  const [printing, setPrinting] = React.useState(false);
  const [formInfo, setFormInfo] = React.useState({});
  const [competentPerson, setCompetentPerson] = React.useState({});
  const [Factory, setFactory] = React.useState([]);
  const [Shop, setShop] = React.useState([]);
  const [Product, setProduct] = React.useState([]);
  const currentRoute = window.location.href;
  const routeParts = currentRoute.split("/");
  const lastSegment = routeParts[routeParts.length - 1];
  const printComponentRef = useRef(null);
  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);
  const [stamLogo, setStamLogo] = React.useState(vssStamp);
  const [certificateNo, setCertificateNo] = React.useState("");
  const [approvedBy, setApprovedBy] = React.useState(null);
  const [letterHead, setLetterHead] = React.useState(true);
  const userType = localStorage.getItem("type");
  const userId = localStorage.getItem("id");
  let customFontSize = formInfo?.name == "Form13" ? "9px" : "11px";

  const fetchformReport = async (id) => {
    setLoading(true);
    try {
      const res = await axiosWithToken.get(`${BASE_URL}reportValues/${id}`);
      const data = res.data[0];
      setApprovedBy(data?.approvedBy);
      setCertificateNo(data?.reportNo);

      if (!data || !data.templateValues) {
        console.log("Template data not found or invalid");
        return;
      }

      const dataObject = data.templateValues && JSON.parse(data.templateValues);

      const newDataObject = { ...dataObject };
      setInputStates(newDataObject);
    } catch (error) {
      console.error("Failed to fetch template: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTemplate = (id) => {
    try {
      setLoading(true);
      axiosWithToken
        .get(BASE_URL + `templates/${id}`)
        .then((res) => {
          let data = res.data[0];
          setFormInfo(data);
          axios.get(data?.url).then((respose) => {
            setInputFields(respose.data);
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  const fetchCompetents = (id) => {
    try {
      setLoading(true);
      axiosWithToken
        .get(BASE_URL + `competents/${id}`)
        .then((res) => {
          let data = res.data?.[0];
          setCompetentPerson(data);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch checklist Competents: ", e);
    }
  };

  const fetchFactory = () => {
    try {
      setLoading(true);
      axiosWithToken
        .get(BASE_URL + `clients`)
        .then((res) => {
          let data = res.data;
          setFactory(data);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch  Factory : ", e);
    }
  };

  const fetchShop = () => {
    try {
      setLoading(true);
      axiosWithToken
        .get(BASE_URL + `shops`)
        .then((res) => {
          let data = res.data;
          setShop(data);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch  Shop : ", e);
    }
  };

  const fetchProduct = () => {
    try {
      setLoading(true);
      axiosWithToken
        .get(BASE_URL + `products`)
        .then((res) => {
          let data = res.data;
          setProduct(data);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log("Failed to fetch  Product : ", e);
    }
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    switch (formInfo?.branchId) {
      case 15:
        setStamLogo(rajasthanStamp);
        break;
      case 16:
        setStamLogo(haryanaStamp);
        break;
      default:
        setStamLogo(vssStamp);
    }
  }, [formInfo?.branchId]);

  // const handlePrint = () => {
  //   const printContent = document.getElementById("formToPrint");
  //   const originalContents = document.body.innerHTML;

  //   if (printContent) {
  //     document.body.innerHTML = printContent.innerHTML;
  //     window.print();
  //     document.body.innerHTML = originalContents;
  //     if (lastSegment !== "print") {
  //       window.location.reload();
  //     }
  //   }
  // };

  const generateDraftImage = async () => {
    let htmlString = `
    <div>
 <img src=${vssLogo} style="width:70%; height:600px; opacity:0.2"/>
        
    </div>`;
    let htmlNode = document.getElementById("header-section");
    htmlNode.innerHTML = htmlString;
    let image = await toPng(htmlNode, { quality: 2, scale: 3 });
    const img = new Image();
    img.src = image;
    htmlNode.innerHTML = "";
    return img;
  };

  const generateLetterHeadHeader = async () => {
  
    let htmlString = `
    <div>
      <img src=${headerImage} style="width:100%; height:130px;"/>
    </div>`;
    let div = document.createElement("div");
    div.innerHTML = htmlString;
    document.body.appendChild(div);
    let canvas = await html2canvas(div, { scale: 1 });
    const img = new Image();
    img.src = canvas.toDataURL();
    document.body.removeChild(div);
    return img;
  };

  const generateLetterHeadFooter = async () => {
    let htmlString = `
    <div>
       <img src=${footerImage} style="width:100%; height:150px;"/>
    </div>`;
    let div = document.createElement("div");
    div.innerHTML = htmlString;
    document.body.appendChild(div);
    let canvas = await html2canvas(div, { scale: 1 });
    const img = new Image();
    img.src = canvas.toDataURL();
    document.body.removeChild(div);
    return img;
  };

  const generatePDF = async () => {
    setDownloadPdfloading(true);
    try {
      const element = printComponentRef.current;
      let pdf = await html2pdf()
        .from(element)
        .set({
          margin: [60, 1, 40, 1],
          pagebreak: { after: "section", mode: ["css", "legacy"] },
          html2canvas: {
            dpi: 192,
            scale: 4,
            letterRendering: true,
            useCORS: true,
          },
          image: { type: 'png', quality: 0.4 },
          jsPDF: {
            orientation: "portrait",
            unit: "pt",
            format: "a4",
            compress: true, 
          },
        })
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages();

      const watermarkImage = await generateDraftImage();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(0, 0, 0);
        pdf.setFont("Courier");

        // Add watermark image at the back of the page
        const pageWidth1 = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = 400;
        const imgHeight =
          (imgWidth * watermarkImage.height) / watermarkImage.width;
        const x1 = (pageWidth1 - imgWidth) / 2;
        const y1 = (pageHeight - imgHeight) / 2;
        letterHead &&
          pdf.addImage(watermarkImage.src, "PNG", x1, y1, imgWidth, imgHeight);

        // border add for contnet
        // const borderWidth = 0.6;
        // const leftMargin = 15;
        // const borderX = leftMargin;
        // const borderY = 5;
        // const rightMargin = 595 - leftMargin * 0.95;
        // pdf.setLineWidth(borderWidth);
        // pdf.rect(borderX, borderY, rightMargin - leftMargin, 750);

        let image = await generateLetterHeadHeader();
        letterHead && pdf.addImage(image, 0, 0, 595, 60);

        image = await generateLetterHeadFooter();
        // letterHead && pdf.addImage(image, 0, 800, 595, 45);
      }

      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `form.pdf`;
      a.click();

      setDownloadPdfloading(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownloadPdfloading(false);
    }
  };

   let extraprops ={
    certificateNo, 
    newTemplateID,
    newReportID,
    stamLogo,
    competentPerson
  }

  const renderStaticSection = () => {
    return (
      <>
        <TableRow>
          <TableCell align="center" sx={{ border: "none" }} colSpan={3}>
            <div
              style={{ justifyContent: "space-between", display: "flex" }}
            ></div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            align="center"
            style={{ border: "none", padding: "0px" }}
            colSpan={5}
          >
            <h6
              style={{
                width: "60%",
                margin: "auto",
                // marginTop: "10px",
                marginBottom: "20px",
              }}
            >
              <i>
                <b>
                  <u>
                    {formInfo?.name?.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </u>
                </b>
              </i>
            </h6>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const TextDisplay = ({ text }) => (
    <div style={{ whiteSpace: "pre-wrap" }}>{text}</div>
  );

  const renderDynamicTable = () => {
    return (
      <>
        {filteredInputFields?.map((field, index) => {
          const label = field?.label || "";
          const numberMatch = label.match(/^\d+(\.\s|[a-z]\) )|^[A-Z]\.\s?/);
          const number = numberMatch ? numberMatch[0].trim() : "";
          let restLabel = label.replace(number, "").trim();

          if (field?.stateKey === "companyName") {
            return null;
          }
          if (restLabel === "Address of the Factory") {
            restLabel = "Name and address of the Factory";
          }

          return (
            <TableRow key={index} style={{ height: "10px" }}>
              <TableCell
                style={{
                  textAlign: "center",
                  padding: "1px 3px",
                  borderRight: "none",
                  fontSize: customFontSize,
                  borderBottom:
                    index === filteredInputFields.length - 1
                      ? "1px solid black"
                      : "none",
                }}
              >
                {number}
              </TableCell>
              <TableCell
                style={{
                  width: "50%",
                  padding: "1px",
                  borderRight: "none",
                  borderBottom:
                    index === filteredInputFields.length - 1
                      ? "1px solid black"
                      : "none",
                }}
              >
                <div
                  style={{
                    marginLeft: "10px",
                    fontSize: customFontSize,
                    textAlign: "left",
                    paddingRight: "5px",
                  }}
                >
                  <b>{restLabel || ""}</b>
                </div>
              </TableCell>
              <TableCell
                style={{
                  width: "1%",
                  textAlign: "center",
                  padding: "1px 3px",
                  borderRight: "none",
                  fontSize: customFontSize,
                  borderBottom:
                    index === filteredInputFields.length - 1
                      ? "1px solid black"
                      : "none",
                }}
              >
                :
              </TableCell>
              <TableCell
                style={{
                  width: "49%",
                  padding: "1px",
                  fontSize: customFontSize,
                  borderBottom:
                    index === filteredInputFields.length - 1
                      ? "1px solid black"
                      : "none",
                }}
              >
                <div
                  style={{
                    marginLeft: "10px",
                    marginRight: "5px",
                    fontSize: customFontSize,
                  }}
                >
                  <b>
                    {field?.stateKey === "addressFactory" ? (
                      <>
                        {/* {Factory?.find(
                          (ele) => ele.id === inputStates?.["factoryId"]
                        )?.name || "Factory name not found"}
                        <br /> */}
                        {inputStates?.["addressFactory"] || " "}
                      </>
                    ) : field?.stateKey === "shopId" ? (
                      Shop?.find(
                        (ele) => ele.id === inputStates?.[field?.stateKey]
                      )?.name || "Shop name not found"
                    ) : field?.stateKey === "factoryId" ? (
                      Factory?.find(
                        (ele) => ele.id === inputStates?.["factoryId"]
                      )?.name || "Factory name not found"
                    ) : field?.stateKey &&
                      ["safeWorkingPressure", "mainatance"]?.includes(
                        field?.stateKey
                      ) ? (
                      inputStates?.[field?.stateKey]
                        ?.split(/\|\s*/)
                        .map((line, index) => (
                          <React.Fragment key={index}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))
                    ) : field?.stateKey === "equipmentId" ? (
                      Product?.find(
                        (ele) => ele.id === inputStates?.[field?.stateKey]
                      )?.name || "Equipment name not found"
                    ) : field?.type === "DatePicker" ? (
                      new Date(
                        inputStates?.[field?.stateKey]
                      ).toLocaleDateString("en-GB")
                    ) : typeof inputStates?.[field?.stateKey] === "string" &&
                      inputStates?.[field?.stateKey]?.includes("\n") ? (
                      <TextDisplay text={inputStates?.[field?.stateKey]} />
                    ) : (
                      inputStates?.[field?.stateKey] || " "
                    )}
                  </b>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };

  const renderSignatureSection = () => {
    function getFormattedDate() {
      const today = inputStates?.reportDate
        ? new Date(inputStates?.reportDate)
        : new Date();
      const formattedDate = today.toLocaleDateString("en-GB");
      return formattedDate;
    }

    function getNextYearDate() {
      const today = inputStates?.reportDate
        ? new Date(inputStates?.reportDate)
        : new Date();
      const nextYear = new Date(today);
      nextYear.setFullYear(today.getFullYear() + 1);
      const formattedNextYearDate = inputStates?.certificateValidity
        ? moment(inputStates?.certificateValidity).format("DD/MM/YYYY")
        : nextYear.toLocaleDateString("en-GB");

      return formattedNextYearDate;
    }

    const selectedTemplate = certificationNote.find(
      (template) => template.id == newTemplateID
    );

    // Replace the {date} placeholder with the formatted date
    const labelWithDate = selectedTemplate
      ? selectedTemplate.label?.replace("{date}", getFormattedDate())
      : "";

   
    return (
      <div>
        {newTemplateID == 5 && (
          <div
            style={{
              textAlign: "left",
              fontSize: "0.5rem",
              fontFamily: "Times New Roman",
              margin: "15px 0px",
            }}
          >
            <h6 style={{ margin: "10px 0px" }}>
              <b>Following Points has been checked:</b>
            </h6>
              <pre><h6>{inputStates?.checkedPoints}</h6></pre>
            {/* <h6>
              1. Machine Placed on proper foundations and no abnormal vibrations
              observed. <br />
              2. The clamping unit and other accessible parts were found
              guarded. Wherever necessarily, warning signs were given.
              <br />
              3. The machine is provided with two push buttons to start the
              operation as to engage both hands of operator, while pressing
              operation. <br />
              4. Machine Safety Interlocking checked by obstructing the safety
              sensors during running of the machine and found the machine
              stopped in that case.
              <br />
              5. Functioning of Hydraulic System components like Non-Return
              Valves, Check valves, Direction Control Valves found OK, during
              Safety Interlocking Testing. <br />
              6. All Pressure Parts are checked for any kind of abnormality and
              found OK. <br />
              7. Machine Positioning Switches & Sensors Monitored during Machine
              Running and found working Ok at the time of operation of the
              machine. <br />
              8. During Examination, I/we found No Safety has been Bypassed and
              there were no modification was done in machine by the user. <br />
            </h6> */}
          </div>
        )}
        <div
          style={{
            textAlign: "left",
            fontSize: "0.6rem",
            fontFamily: "Times New Roman",
            marginTop: "5px",
          }}
        >
          <h6
            dangerouslySetInnerHTML={{
              __html: labelWithDate,
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pageBreakInside: "avoid",
            marginTop: "20px",
          }}
        >
          <div>
            <QRCode
              value={`${DOMAIN}/#/printForm/${newReportID}/${newTemplateID}/print`}
              align="center"
              size={80}
            />
            <h6
              style={{
                fontSize: "14px",
                margin: "5px 0px",
                textAlign: "left",
                marginTop: "10px",
                fontFamily: "Times New Roman",
              }}
            >
              <b>
                Certificate No. : {certificateNo || ""} <br />
                Date of Issue :{" "}
                {moment(inputStates?.reportDate).format("DD/MM/YYYY")} <br />
                Next Testing Due on :{" "}
                {moment(inputStates?.certificateValidity).format(
                  "DD/MM/YYYY"
                )}{" "}
                <br />
              </b>
            </h6>
          </div>

          <div
            style={{
              alignItems: "center",
              textAlign: "right",
              marginTop: "40px",
              // margin: "130px 0px",
            }}
          >
              {letterHead && (
            <div>
                <img style={{ height: "70px" }} src={Sign} alt="Sign" />
                <img style={{ height: "100px" }} src={stamLogo} alt="stamp" />
            </div>
              )}
            <div>
              {" "}
              <h6 style={{ fontSize: "14px", fontFamily: "Times New Roman" }}>
                <b>{competentPerson?.personName}</b>
              </h6>{" "}
              <h6 style={{ fontSize: "14px", fontFamily: "Times New Roman" }}>
                <b>
                  Chartered Engineer
                  <br />
                  Competent Person
                  <br />
                  FOR HimTex Global
                </b>
              </h6>
              {/* <i>
                {" "}
                <h6 style={{ fontSize: "18px", fontFamily: "Times New Roman" }}>
                  <b>{competentPerson?.qualification}</b>
                </h6>{" "}
              </i> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  function filterInputFields(inputFields, stateKeyArray) {
    return inputFields.filter(
      (field) => !stateKeyArray.includes(field.stateKey)
    );
  }

  useEffect(() => {
    const stateKeyArray = [
      "competentPerson",
      "reportNumber",
      "reportDate",
      // "factoryId",
      "renewal",
      "shopId",
      "equipmentId",
      "totalTest",
      "capacity",
      "renewalInformation ",
      "inspectionDate ",
      "certificateValidity ",
      // "distinctiveNumber",
      "inspectionDate",
      "utrasonicTestDate",
      "hydraulicTestDate",
      "internalTestDate",
      "internalExaminationDueDate",
      "certificateValidityDate",
      "certificateValidity",
      "certificateNumber",
      "conclusionOfCertificate",
      "inspectedOn",
      "hydrostaticTest",
      "dateOfLastTest",
      "certifyDate",
      "reportStateName",
      "reportNumber",
    ];
    const filteredInputFields = filterInputFields(inputFields, stateKeyArray);
    setfilteredInputFields(filteredInputFields);
  }, [inputFields]);

  const handleApprove = () => {
    try {
      axiosWithToken
        .patch(BASE_URL + `reportValues/${newReportID}`, { approvedBy: userId })
        .then((res) => {
          refresh();
        });
    } catch (e) {
      console.log("Failed to fetch  Product : ", e);
    }
  };

  // useEffect(() => {
  //   if (lastSegment === "print") {
  //     setTimeout(() => {
  //       handlePrint();
  //     }, 1000);
  //   }
  // }, []);

  useEffect(() => {
    if (newTemplateID > 0) {
      fetchTemplate(newTemplateID);
    }
    if (newReportID > 0) {
      fetchformReport(newReportID);
    }
  }, [newReportID, newTemplateID]);

  useEffect(() => {
    if (inputStates?.competentPerson)
      fetchCompetents(inputStates?.competentPerson);
  }, [inputStates?.competentPerson]);

  useEffect(() => {
    fetchProduct();
    fetchShop();
    fetchFactory();
  }, []);

  return (
    <>
      {reportID && (
        <Toolbar
          sx={{
            padding: 0,
            overflow: "auto",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2, // Add space between elements
          }}
        >
          <Autocomplete
            size="small"
            id="invoice_view_letterhead"
            options={[
              { id: 1, label: "With Letter Head" },
              { id: 2, label: "Without Letter Head" },
            ]}
            renderInput={(params) => (
              <TextField {...params} label="Letter Head" />
            )}
            sx={{ height: "40px", width: "250px" }} // Match the height to Button
            onInputChange={(event, newInputValue) => {
              if (
                newInputValue === "With Letter Head" ||
                newInputValue === ""
              ) {
                setLetterHead(true);
              } else if (newInputValue === "Without Letter Head") {
                setLetterHead(false);
              }
            }}
          />

          <Button
            variant="contained"
            size="small"
            sx={{ height: "40px" }}
              onClick={()=>generatePDF1(letterHead, formInfo, inputStates,filteredInputFields, Factory, Shop, Product,extraprops, competentPerson)}
            // disabled={!approvedBy}
          >
            Print Report
          </Button>
        </Toolbar>
      )}

      <div
        id="formToPrint"
        ref={printComponentRef}
        style={{
          width: "100%",
          fontSize: "16px",
          margin: "auto",
          position: "relative",
          fontFamily: "Times New Roman",
        }}
      >
        <div style={{ width: "100%" }} id="header-section"></div>
        <div
          style={{
            width: "96%",
            fontSize: "16px",
            fontFamily: "Times New Roman",
            margin: "auto",
            // padding: "7px",
            position: "relative",
          }}
        >
          <Table>
            <TableBody>
              {renderStaticSection()}
              {renderDynamicTable()}
            </TableBody>
          </Table>
          {renderSignatureSection()}
        </div>

        {downloadPdfloading && (
          <DownloadPdfLoaderModal loading={downloadPdfloading} name={"Pdf"} />
        )}
      </div>
      {/* {userType == 1 && approvedBy === null && (
        <Button
          variant="contained"
          size="small"
          sx={{
            marginRight: "20px",
            backgroundColor: "green",
            color: "white",
            alignSelf: "flex-start", // Aligns button to the left side in flex containers
          }}
          onClick={handleApprove}
        >
          Approve
        </Button>
      )} */}
    </>
  );
};

export default FormPrint;
